import { render, staticRenderFns } from "./panel_saleRecord.vue?vue&type=template&id=48be15e6&scoped=true&"
import script from "./panel_saleRecord.vue?vue&type=script&lang=js&"
export * from "./panel_saleRecord.vue?vue&type=script&lang=js&"
import style0 from "./panel_saleRecord.vue?vue&type=style&index=0&id=48be15e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be15e6",
  null
  
)

export default component.exports